import { RouteComponentProps, Router } from "@gatsbyjs/reach-router";
import { APAsyncButton, APColumn, APExpanded, APImage, APRow, APSizedBox, APText } from "ap-components";
import React from "react";
import MultipleMandate from "./MultipleMandate";
import SingleMandateRoutes from "./SingleMandateRoutes";

export default function Mandate(props: RouteComponentProps) {
    return (
        <APColumn mainAxisSize="max" crossAxisAlignment="stretch">
            {
                <APColumn >
                    <APSizedBox height="16px" />
                    <APRow mainAxisAlignment="center">
                        <APImage src="/Assetplus_Logo.png" height={24} />
                    </APRow>
                    <APSizedBox height="16px" />
                </APColumn>
            }
            <APExpanded>
                <Router>
                    <MultipleMandate path="/" />
                    <SingleMandateRoutes path=":mandateId/*" />
                </Router>
            </APExpanded>
        </APColumn>
    )
}

export function Heading({ text, desc }: { text: string, desc: string | React.ReactNode }) {
    return (
        <APColumn crossAxisAlignment="stretch">
            <APText style={{ fontWeight: 600, lineHeight: 1.5, color: "#232730", fontSize: "16px" }}>
                {text}
            </APText>
            <APSizedBox height="8px" />
            {
                typeof desc === "string" ?
                    <APText style={{ color: "#41495b", lineHeight: 1.43, fontSize: "14px" }}>
                        {desc}
                    </APText>
                    :
                    desc
            }

        </APColumn>
    )
}

export function Icons({ icon, text, style }: { icon: string, text: string, style?: React.CSSProperties }) {
    return (
        <APRow gap="8px" style={{ color: "#41495b", fontSize: "14px", lineHeight: 1.43, ...style }} crossAxisAlignment="start">
            <APImage src={`/img/${icon}.svg`} />
            <APExpanded style={{ padding: "2px 0" }}>
                <span>{text}</span>
            </APExpanded>
        </APRow>
    )
}

export function Note({ text }: { text: string }) {
    return (
        <Icons
            style={{ padding: "8px", background: "#dddaf1", borderRadius: "8px", color: "#463795" }}
            icon="ic_approval"
            text={text}
        />
    )
}

export function Button({ label, onClick }: { label: string | JSX.Element, onClick?: () => Promise<void> }) {
    return (
        <APAsyncButton
            color="primary"
            variant="contained"
            onClick={onClick}
            size="large"
        >
            {label}
        </APAsyncButton>
    )

}